<template>
  <b-container>
    <b-row>
      <h2>
        {{ $t("checklist.sidebar.Create") + " " + $t("sidebar.brandVehicle") }}
      </h2>
    </b-row>

    <success-fade-alert ref="alertSuccess" :msg="alert.success" />
    <fade-alert-danger ref="alertDanger" :msg="alert.error" />

    <b-row>
      <b-button @click="voltar()" size="sm">
        {{ $t("geral.back") }}
      </b-button>
    </b-row>

    <b-row class="mt-2">
      <b-col lg="6" md="6" sm="6">
        <brand-vehicle :model="model" :modelstate="modelstate" />
      </b-col>
    </b-row>

    <b-row style="margin-top: 40px">
      <b-button @click="save" size="sm">
        {{ $t("geral.save") }}
      </b-button>
    </b-row>
  </b-container>
</template>

<script>
export default {
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    BrandVehicle: () =>
      import("@/components_rms/System/BrandVehicle/BrandVehicle.vue"),
  },
  data() {
    return {
      modelstate: {},
      alert: {
        error: "Erro ao criar registro: ",
        success: "Registro criado com sucesso",
      },
      model: {
        name: null,
      },
    };
  },
  methods: {
    save() {
      this.modelstate = {};
      let obj = {
        name: this.model.name,
      };
      this.$apiScheduler
        .post("/brand/create/", obj)
        .then((response) => {
          if (response.data.status == 500) {
            this.alert.error = response.data.title;
            this.$refs.alertDanger.show();
          } else {
            this.$refs.alertSuccess.show();
            this.clearFields();
          }
          this.clearFields();
        })
        .catch((error) => {
          if (error.response.data.errorCode === 400) {
            this.alert.error = error.response.data.errorMessage;
            this.$refs.alertDanger.show();
          }
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    clearFields() {
      this.model = {
        name: null,
      };
    },
    voltar() {
      this.$router.go(-1);
    },
  },
};
</script>